import { StrictMode } from "react";
import ReactDOM from "react-dom";
import { ChakraProvider } from "@chakra-ui/react";
import { Web3ReactProvider } from "@web3-react/core";
import { Web3Provider } from '@ethersproject/providers'

import App from "./App";

const getLibrary = (provider) => {
  const library = new Web3Provider(provider);
  library.pollingInterval = 8000; // frequency provider is polling
  return library;
};

const rootElement = document.getElementById("root");
ReactDOM.render(
  <StrictMode>
    <ChakraProvider>
      <Web3ReactProvider getLibrary={getLibrary}>
        <App />
      </Web3ReactProvider>
    </ChakraProvider>
  </StrictMode>,
  rootElement
);




// function getLibrary(provider: any): Web3Provider | Harmony {
//   var library: Web3Provider | Harmony

//   if (provider?.chainType === 'hmy') {
//     library = provider.blockchain
//   } else {
//     library = new Web3Provider(provider)
//     library.pollingInterval = 12000
//   }

//   return library
// }
